export type SiteLocale = "es" | "en";

export const localeFromPath = (pathname = window.location.pathname): SiteLocale =>
  pathname === "/en" || pathname.startsWith("/en/") ? "en" : "es";

export const localizedCopy = {
  es: {
    title: "Daniel Montana — Modelo y creador de contenido",
    description: "Daniel Montana — modelo y creador de contenido de fitness y lifestyle.",
    socialDescription: "Contenido exclusivo, fitness y lifestyle de Daniel Montana. Accede a fotos, videos y actualizaciones privadas.",
    officialSite: "Sitio oficial",
    intro: "Lo que ves en redes es solo una parte.",
    exclusive: "Ver contenido exclusivo",
    privateGroup: "Entrar al grupo privado",
    selectedWork: "Trabajo seleccionado",
    galleryTitle: "Momentos<br />que hablan.",
    galleryLead: "Una selección de retratos, entrenamiento, lifestyle y sesiones editoriales.",
    contentNotice: "Algunas imágenes son previews de contenido exclusivo y pueden aparecer difuminadas.",
    exclusiveAccess: "Accesos exclusivos",
    moreFromDaniel: "Más de Daniel",
    exclusiveTitle: "Contenido<br />exclusivo",
    exclusiveDescription: "Fotos, videos y actualizaciones que no aparecen en redes.",
    privateAccess: "Acceso privado",
    privateTitle: "Grupo<br />privado",
    privateDescription: "Más contenido y detalles para entrar al grupo en Telegram.",
    aboutTitle: "Más allá<br />del frame.",
    aboutDescription: "Daniel Montana es creador de contenido enfocado en fitness, lifestyle, fotografía y momentos que conectan.",
    follow: "Sigue a Daniel",
    socialTitle: "Encuéntrame<br />también aquí.",
    collaborations: "Colaboraciones",
    contactTitle: "¿Trabajamos<br />juntos?",
    contactLead: "Campañas, fotografía, eventos, marcas y proyectos que tengan algo que contar.",
    contact: "Escríbeme",
    privacy: "Privacidad",
    footer: "Diseñado para conectar.",
    restrictedPreview: "Preview exclusivo",
    subscriberOnly: "Disponible para suscriptores.",
    showPreview: "Ver preview",
    hidePreview: "Ocultar preview",
    placeholder: "Placeholder: {label}. Sustituir por fotografía pública aprobada de Daniel Montana.",
    photoFallback: "Fotografía de Daniel Montana",
    aboutFallback: "Placeholder para fotografía natural de Daniel Montana",
    pendingConfig: "Configuración pendiente.",
    pendingConfigBody: "Define {keys} en tu archivo .env antes de publicar.",
    privacyPreferences: "Preferencias de privacidad",
    yourPrivacy: "Tu privacidad",
    privacyMessage: "Usamos analítica para entender qué secciones y enlaces funcionan mejor. Puedes aceptar o rechazarla; la experiencia no cambia.",
    reject: "Rechazar",
    accept: "Aceptar",
    telegramGreeting: "Hola Daniel, vengo de tu página y quiero información para entrar al grupo privado.",
    telegramFree: "Grupo Telegram (Gratis)",
    languageLabel: "Idioma",
    birthdayDate: "2 de septiembre",
    birthdayTitle: "¡Feliz cumpleaños, Daniel!",
    birthdayMessage: "Hoy celebramos a Daniel. Gracias por acompañarlo y ser parte del camino.",
    birthdayClose: "Continuar celebrando",
  },
  en: {
    title: "Daniel Montana — Model & Content Creator",
    description: "Daniel Montana — model and content creator focused on fitness and lifestyle.",
    socialDescription: "Exclusive fitness and lifestyle content from Daniel Montana. Explore private photos, videos and updates.",
    officialSite: "Official site",
    intro: "What you see on social is only part of the story.",
    exclusive: "Explore exclusive content",
    privateGroup: "Join the private group",
    selectedWork: "Selected work",
    galleryTitle: "Moments that<br />speak for themselves.",
    galleryLead: "A selection of portraits, fitness, lifestyle, and editorial work.",
    contentNotice: "Some images are previews of exclusive content and may appear blurred.",
    exclusiveAccess: "Exclusive access",
    moreFromDaniel: "More from Daniel",
    exclusiveTitle: "Exclusive<br />content",
    exclusiveDescription: "Photos, videos, and updates you won’t find on social media.",
    privateAccess: "Private access",
    privateTitle: "Private<br />group",
    privateDescription: "More content and details on joining the Telegram group.",
    aboutTitle: "Beyond<br />the frame.",
    aboutDescription: "Daniel Montana is a content creator focused on fitness, lifestyle, photography, and moments that connect.",
    follow: "Follow",
    socialTitle: "Find me<br />here too.",
    collaborations: "Collaborations",
    contactTitle: "Let’s work<br />together.",
    contactLead: "Campaigns, photography, events, brands, and projects with a story to tell.",
    contact: "Get in touch",
    privacy: "Privacy",
    footer: "Designed to connect.",
    restrictedPreview: "Exclusive preview",
    subscriberOnly: "Available to subscribers.",
    showPreview: "View preview",
    hidePreview: "Hide preview",
    placeholder: "Placeholder: {label}. Replace with an approved public photo of Daniel Montana.",
    photoFallback: "Photo of Daniel Montana",
    aboutFallback: "Placeholder for a natural photograph of Daniel Montana",
    pendingConfig: "Configuration needed.",
    pendingConfigBody: "Set {keys} in your .env file before publishing.",
    privacyPreferences: "Privacy preferences",
    yourPrivacy: "Your privacy",
    privacyMessage: "We use analytics to understand which sections and links work best. You can accept or reject it; your experience will not change.",
    reject: "Reject",
    accept: "Accept",
    telegramGreeting: "Hi Daniel, I’m visiting from your website and would like information about joining the private group.",
    telegramFree: "Telegram group (Free)",
    languageLabel: "Language",
    birthdayDate: "September 2",
    birthdayTitle: "Happy birthday, Daniel!",
    birthdayMessage: "Today we celebrate Daniel. Thank you for being here and being part of the journey.",
    birthdayClose: "Keep celebrating",
  },
} as const;

export type LocalizedCopy = (typeof localizedCopy)[SiteLocale];
